import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 🚀 Função para mandar a altura da página ao parent (iframe)
function sendHeight() {
  const height = document.body.scrollHeight;
  window.parent.postMessage({ iframeHeight: height }, "*");
}

// Dispara no load e resize
window.addEventListener("load", sendHeight);
window.addEventListener("resize", sendHeight);

// Observa mudanças no DOM (para gráficos, rotas, etc.)
const observer = new MutationObserver(sendHeight);
observer.observe(document.body, { childList: true, subtree: true });

// Chama uma vez ao iniciar
sendHeight();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
